import Phaser, { Scene } from 'phaser';
import { MessageBox } from './MessageBox';
import { Backdrop } from './Backdrop';
import { HowToPlayMessage } from './HowToPlayMessage';
import { AudioScene } from '../AudioScene';
import { PrizesMessage } from './PrizesMessage';
import { RevealGame } from '@pbl/digital-games-core/lib/core/RevealGame';
import {Button} from "./Button";
import Slider from "phaser3-rex-plugins/plugins/input/slider/Slider";

export class MenuComponent extends AudioScene {
  private settings;
  private backdrop;
  private revealGame;
  private slider;
  private sliderObj;

  constructor(scene: Scene, messageBoxWidth: number = 0, messageBoxHeight: number = 0, revealGame: RevealGame, audioManager) {
    super('CrosswordScene', 'CrosswordAZ');
    this.backdrop = new Backdrop(scene);
    this.revealGame = revealGame;
    this.settings =  new MessageBox(
      scene,
      messageBoxWidth * 0.8,
      messageBoxHeight * 0.45,
      [],
      [
        { name: 'menuclose', method: this.close(scene), width: 45, height: 45, x: 560, y: 35},
        { name: 'menu-htp', method: this.openHowToPlay(scene, messageBoxWidth, messageBoxHeight), width: 370, height: 85, x: 300, y: 120},
        { name: 'menu-prize-table', method: this.displayPrizesMessage(scene), width: 370, height: 85, x: 300, y: 450},
        { name: 'exitgame', method: this.exitGame, width: 370, height: 85, x: 300, y: 550}
      ],
      [
        { width: 370, height: 85, name: 'menu-volume-btn', x: 0.5, y: 0.4 }
      ]
    );
    this.audioManager = audioManager;
    this.addAudioButtons(scene);

  }

  autoRevealNextCallTile() {
    this.backdrop.destroy();
    this.settings.destroy();
    this.revealGame.allTilesRevealed.notify();
  }

  private close = (scene) => () => {
    scene.tweens.add({
      alpha: 0,
      ease: 'Linear',
      duration: 300,
      targets: this.settings,
      repeat: 0,
      onComplete: () => {
        this.sliderObj.destroy();
        this.slider.destroy();
        this.settings.destroy();
        this.backdrop.destroy();
      }
    });

  };

private exitGame() {
  // @ts-ignore
  if (typeof PblInterface !== 'undefined') {
    // @ts-ignore
    PblInterface.game.exit();
  }
}

  private openHowToPlay = (scene, gameWidth, gameHeight) => () => {
    this.settings.setDepth(-1);
    new HowToPlayMessage(scene, gameWidth, gameHeight, () => {
      this.cancelCallBack()
    });
  }

  cancelCallBack() {
    this.settings.setDepth(1000)
  }

  addAudioButtons (scene: Phaser.Scene) {

    const volumeChangeCallback = (v) => {
      this.audioManager.setVolume(v);
      console.log("volume: " + v);
    };

    this.sliderObj = scene.add
      .image(0, 0, 'menu-sound-node')
        .setDisplaySize(45,45)
        .setOrigin(0.5)
        .setDepth(1000);

    this.slider = new Slider(this.sliderObj, {
      endPoints: [
        {x:220, y:700},
        {x:530, y:700}
      ],
      value:this.audioManager.getVolume(),
      valuechangeCallback: volumeChangeCallback
    });

    const track = scene.add
        .image(300, 330, 'menu-sound-track')
        .setDisplaySize(350, 20)
        .setOrigin(0.5);

    this.settings.add(track);

    let muteButton: Button;
    let maxButton: Button;

    const muteCallback = () => {
      this.slider.setValue(0);
    };

    const maxCallback = () => {
      this.slider.setValue(100);
    };

    muteButton = new Button(scene, 90, 330, 'menu-mute', muteCallback, 'button-press', 40, 40);
    maxButton = new Button(scene, 510, 330, 'menu-max', maxCallback,'button-press', 40, 40);
    this.settings.add(muteButton);
    this.settings.add(maxButton);

  }

  private displayPrizesMessage= (scene: Scene) => () =>  {
    this.settings.setDepth(-1);


    new PrizesMessage(scene,() => {
      this.cancelCallBack()
    } );
  }


}
